import axios from 'axios';
import { backendEndpoint } from './constants';

export const api = axios.create({
  baseURL: backendEndpoint,
});

export default api;
